import { render } from "./professionUploadVideo.vue?vue&type=template&id=efe6cc40&scoped=true"
import script from "./professionUploadVideo.vue?vue&type=script&lang=js"
export * from "./professionUploadVideo.vue?vue&type=script&lang=js"

import "./professionUploadVideo.vue?vue&type=style&index=0&id=efe6cc40&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efe6cc40"]])

export default __exports__